import { createContext } from 'react';

/**
 * The merchant's own words, by full content key - for a renderer that is not
 * wearing a whole theme document.
 *
 * The storefront and the theme preview both provide a `StorefrontTheme`
 * already, and a merchant's copy lives on it, so neither of them needs this:
 * `useContent` reads their document's `content` straight off the theme
 * context. What needs it is the customiser, which renders the shop's own
 * components against a *draft* being edited - no shell, no published theme -
 * and has to be able to say "these are the words, as of this keystroke".
 *
 * `null` means "nobody has said", which is different from "there are none":
 * the first falls through to the theme context, and the second - an empty map
 * - is a complete answer meaning this merchant has changed nothing. Both end
 * up rendering the theme's own words, and the distinction is what keeps a
 * customiser preview of an untouched theme from quietly showing the published
 * shop's copy instead.
 */
export const StorefrontContentContext = createContext<Readonly<Record<string, string>> | null>(
  null,
);
